import { Component, OnInit } from '@angular/core';
import { serviceURLService } from '../service/serviceURL';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { environment } from '../../environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
import * as $ from 'jquery';
declare var $: any;

@Component({
  selector: 'app-polyclinic',
  templateUrl: './polyclinic.component.html',
  styleUrls: ['./polyclinic.component.css']
})
export class PolyclinicComponent implements OnInit {

  thankyou: boolean = false;
  loading: boolean = false;
  error: any;
  data: any = {};
  url:string;
  specializationType: string;
  userData: any;
  disable: boolean = true;
  hasEcard:boolean;
  MongoDataToSaved:any={};
  private onDestroy$: Subject<void> = new Subject<void>();
  name: string;
  email: string;
  mobile: string;
  useId:any;
  isMentalHealth: boolean = false;

  constructor(private serviceURLService: serviceURLService,private router: Router, private activatedRoute: ActivatedRoute) { 
    this.name = localStorage.getItem('name');
    this.email = localStorage.getItem('email');
    this.mobile = localStorage.getItem('mobileNumber');
    this.useId=localStorage.getItem('userID')

    this.activatedRoute.queryParamMap.subscribe(params => {
      const service = params.get('service');

      if (service === 'mentalHealth') {
        this.isMentalHealth = true;
      } else {
        this.isMentalHealth = false;
      }
    });
  }

  ngOnInit() {
    this.getUserData();
    this.CheckIfEcardUser();
  }

  bookAppointment(specialization) {
    const obj={
      specialization:specialization,
      userId: localStorage.getItem('userID')
    }
    this.serviceURLService.getPolyStatus(obj).subscribe((success: any) => {
   
     console.log(success.response)
    
      this.disable=!success.response

      console.log(success.response,this.disable)
     
    this.specializationType = specialization;
    })
  }

  getUserData() {
    this.loading = true;
    this.serviceURLService.getUserData().pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      this.userData = successData.response.completeUserData;
      this.loading = false;
    }, errorData => {
      if (errorData.error.status === 403) {
        this.error = errorData.error.message;
      }
    })
  }

  confirmAppointment(specialization) {
    $("#thankyou").modal("show");
    this.savePolyclinicInMongo(specialization);
    this.data = {
      name: this.userData.name ? this.userData.name : localStorage.getItem("name"),
      email: this.userData.email ? this.userData.email : localStorage.getItem("email"),
      mobile: this.userData.mobile ? this.userData.mobile : localStorage.getItem("mobileNumber"),
      companyName: this.userData.company ? this.userData.company : localStorage.getItem("companyName"),
      specialization: specialization
    }
    this.serviceURLService.sendPolyclinicRequestMail(this.data).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
    }, errorData => {
      if (errorData.error.status === 403) {
        this.error = errorData.error.message;
      }
    })

  }

  savePolyclinicInMongo(specialization){
    this.MongoDataToSaved = {
      name: this.userData.name ? this.userData.name : localStorage.getItem("name"),
      email: this.userData.email ? this.userData.email : localStorage.getItem("email"),
      mobile: this.userData.mobile ? this.userData.mobile : localStorage.getItem("mobileNumber"),
      company_name: this.userData.company ? this.userData.company : localStorage.getItem("companyName"),
      specialization: specialization,
      userId:this.userData._id ? this.userData._id : localStorage.getItem("userID"),
    }
    this.serviceURLService.savePolyData(this.MongoDataToSaved).subscribe((successData: any) => {
    }, errorData => {
      if (errorData.error.status === 403) {
        this.error = errorData.error.message;
      }
    })

  }

  redirectToMfine(){
    this.saveClickEvent("M-Fine-DSC");
    let data 
    let firstname = localStorage.getItem('name').split(' ')[0]
    let lastname = localStorage.getItem('name').split(' ')[1]
    let email = localStorage.getItem('email')
    let  mobileNumber = '91'+localStorage.getItem('mobileNumber')
    data =  {
      "user_type": "patient",
      "target_url" : environment.targetUrl,
      "user_details": {
      "mobile_number": mobileNumber,
      "firstname": firstname,
      "lastname": lastname,
      "email": email
      }
    }
    this.serviceURLService.reditectToMfineApp(data).subscribe((successData: any) => {
      this.url = successData.redirect_url;
       console.log(this.url, "url print here")
       // Open the URL in a new tab
          const a = document.createElement('a');
          a.href = this.url;
          a.target = '_blank';
          a.rel = 'noopener noreferrer';
          a.click();

          setTimeout(() => {
            this.router.navigate(['/home']);
          }, 500);
          // Close the new tab
       console.log("going to call subscribe API")
         let planData = {
          "plan_id": environment.mfinePlanId,
          "mobile_number": mobileNumber
         }
         this.serviceURLService.mfineSubscribeAPI(planData).subscribe((successData:any)=>{

         }),errorData =>{

         }
    }), errorData => {
    
    }

    
  }



  CheckIfEcardUser(){
    this.loading=true
    var userId = localStorage.getItem("userID")
    this.serviceURLService.getPoliciesEcards(userId).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      const insuranceDetails = successData.response.notifyPolicy;
      console.log(insuranceDetails)
      if(insuranceDetails.length>0){
        this.hasEcard=false
         this.loading=false
      }
      else{
        this.hasEcard=true
        this.loading=false
      }
    }, errorData => {
       this.loading = false;
        this.router.navigate(['login']);
    })
  }

  saveClickEvent(clickOn) {
    var clickedData= {
     email: this.email,
     name: this.name,
     mobile: this.mobile,
     id:this.useId,
     type: clickOn
     }
   this.serviceURLService.saveClicked(clickedData).subscribe((successData: any) => {
     console.log("clicked data saved",clickOn);
   }, errorData => {
     console.log("clicked datanot saved",clickOn);
    
   })
 }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
